'use client';

import React from 'react';
import Header from '../global/partials/Header';
import Footer from '../global/partials/Footer';
import { PageWhyPropTradingSchema } from '@/sanity/pages/PageWhyPropTradingTemplate';
import HeroSection from '../pageComponents/why-prop-trading/HeroSection';
import IntroSection from '../pageComponents/why-prop-trading/IntroSection';
import WhyChallengeSection from '../pageComponents/why-prop-trading/WhyChallengeSection';
import PropVsSelfFundedSection from '../pageComponents/why-prop-trading/PropVsSelfFundedSection';
import TurboRouteSection from '../pageComponents/why-prop-trading/TurboRouteSection';
import HowIqTreatsSection from '../pageComponents/why-prop-trading/HowIqTreatsSection';
import MeansForYouSection from '../pageComponents/why-prop-trading/MeansForYouSection';
import FaqSection from '../pageComponents/global/sections/FaqSection';
import TraderValuesSection from '../pageComponents/global/sections/TraderValuesSection';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';
import HeaderV2 from '../global/partials/HeaderV2';

export default function PageWhyPropTradingJSX({
  data,
}: {
  data: PageWhyPropTradingSchema;
}) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType={'main'} // showBorder
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />
      <IntroSection data={data} />
      <WhyChallengeSection data={data} />
      <PropVsSelfFundedSection data={data} />
      <TurboRouteSection data={data} />
      <HowIqTreatsSection data={data} />
      <MeansForYouSection data={data} />
      {/* <TraderValuesSection className="lg:pt-[18rem] pt-[10rem]" data={data} /> */}
      <FaqSection className="lg:pt-[20rem] pt-[10rem]" data={data} />

      <ScrollingBanner
        className="bg-[#f4f5f5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
